import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { AppContext } from '@/AppContext';
import { ECCommonErrorBlock } from '@/components/Forms/ECCommonErrorBlock';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECSelectField } from '@/components/Forms/ECSelectField';
import { ECPhotoField } from '@/components/Forms/ECPhotoField';

const HallEditForm = props => {
  const { meetupId, form, initial } = props;

  return (
    <>
      <ECCommonErrorBlock form={form} />
      <Grid container spacing={3}>
        <Grid size={12}>
          <ECTextField label='Название' name='name' initial={initial} form={form} />
        </Grid>
        <Grid size={12}>
          <ECTextField label='Как добраться' name='location' initial={initial} form={form} multiline rows={4} />
        </Grid>
        <Grid size={12}>
          <ECPhotoField label='Фото' name='imageId' form={form} initial={initial} />
        </Grid>
      </Grid>
    </>
  );
};

export default HallEditForm;
